import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SG_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SG_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SG_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v12h32V0H0z", fill: "#E31D1C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.869 10.59S6.043 9.454 6.043 6.374c0-3.079 2.826-4.178 2.826-4.178-1.373-.348-5.017-.037-5.017 4.178 0 4.216 3.589 5.011 5.017 4.216zm.725-.509l.81-.489.829.49-.203-.956.674-.753h-.913l-.387-.892-.386.892-.914.039.675.714-.185.955zm3.756-.544l-.811.49.185-.955-.675-.715.914-.039.387-.891.386.891h.913l-.674.754.203.955-.828-.49zM11.287 5.77l.81-.49.83.49-.204-.955.674-.753h-.913l-.386-.892-.387.892-.914.038.675.715-.185.955zM9.371 7.223l-.81.49.184-.956-.675-.714.914-.039.387-.892.387.892h.912l-.673.753.203.955-.829-.49zm4.547.445l.81-.489.829.49-.203-.956.674-.753h-.913l-.386-.892-.387.892-.914.039.675.714-.185.955z",
      fill: "#F1F9FF"
    }
  )))
), a = t;
export {
  a as default
};
